import axios from "axios";
import {
  GetGroupedSuppliesRequestResponse,
  GetSuppliesRequestBody,
  GetSuppliesRequestResponse,
} from "../../models/supplies/supplies.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const getGroupedSupplies = async (
  requestBody: GetSuppliesRequestBody,
  token: string,
  abortSignal: AbortSignal
): Promise<GetGroupedSuppliesRequestResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CUPS, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getSupplies = async (
  requestBody: GetSuppliesRequestBody,
  token: string,
  abortSignal: AbortSignal
): Promise<GetSuppliesRequestResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CUPS, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

export { getGroupedSupplies, getSupplies };
